import React from "react";
import assign from "object-assign";
//import { Link } from "react-router";

const data = [
    {
        name: "two-story",
        url: "/public/img/in-the-home/slides/two-story.png",
        urlMobile: "/public/img/in-the-home/slides/two-story.png",
        summary: "Spread across 3,500 sq. ft. and two floors, this home has a modern, open floor plan. Distance is the main issue.",
        pins: [
            "The primary eero sits next to the TV in the living room, where it connects to the family's modem.",
            "There's another eero in the home office just off the kitchen. It zaps WiFi to the room above it too.",
            "There’s an eero on the upstairs landing. It has line-of-sight down the staircase to the eero in the living room. For stairways, one eero near the bottom and another near the top often works well.",
            "Another eero has a diagonal line of sight into the upstairs master bedroom through its door. Signal goes through doors easier than walls. Mom can take a video call for work from the deck."
        ]
    },
    {
        name: "ranch",
        url: "/public/img/in-the-home/slides/ranch.png",
        urlMobile: "/public/img/in-the-home/slides/ranch.png",
        summary: "The home’s a long L-shape. Thanks to an addition a few years back, some of the interior walls are brick (great against wolves, but bad for WiFi).",
        pins: [
            "The primary eero is in the office. The home's cable pipe runs through the garage.",
            "Another eero is about 40 ft. away on a table in the living room. There’s rough line-of-sight with the primary eero.",
            "Down the hallway in the bedroom, there's a third eero. It's best to place your eeros just shy of dead zones rather than right in the middle of them."
        ]
    },
    {
        name: "brownstone",
        url: "/public/img/in-the-home/slides/brownstone.png",
        urlMobile: "/public/img/in-the-home/slides/brownstone.png",
        summary: "Besides being historic, the home’s four stories present a vertical challenge. And who wouldn’t want WiFi on that roof deck with a view?",
        pins: [
            "The primary eero is in the basement, where the cable pipe comes into the house.",
            "Another eero is up one floor in the living room. It provides signal to the main floor of the home, as well as the balcony and backyard.",
            "A third eero is, fittingly, on the third floor. This one is placed near the staircase to help signal snake up to the top floors of the home.",
            "A fourth and final eero is in a nook off of the master bedroom. It's at a slight diagonal to the eero on the floor below."
        ]
    },
    {
        name: "loft",
        url: "/public/img/in-the-home/slides/loft.png",
        urlMobile: "/public/img/in-the-home/slides/loft.png",
        summary: "Exposed brick interior walls, while chic, are like kryptonite for WiFi signal. Also: This building is chock-full of bandwidth-hungry young professionals and their competing WiFi networks.",
        pins: [
            "The primary eero is right next to the TV. Fast WiFi for slow mornings, not a problem.",
            "There’s another eero in the bedroom for late-night streaming."
        ]
    }
];

let HouseSelect = React.createClass({
    getInitialState() {
        return {
            data: data.map((house, i) => assign(house, {id: i})),
            current: null,
            last: 0,
            next: 0,
            prev: 0,
            currentPin: 0,
            lastPin: 0,
            mobile: {}
        };
    },
    selectHouse(id) {
        this.setState({
            current: id,
            last: this.state.current,
            next: id < this.state.data.length - 1 ? id + 1 : 0,
            prev: id > 0 ? id - 1 : this.state.data.length - 1,
            currentPin: 0,
            lastPin: 0
        });
    },
    selectPin(i) {
        this.setState({
            currentPin: i,
            lastPin: this.state.currentPin
        });
    },
    toggleMobileSlide(slide) {
        this.setState({
            mobile: assign(this.state.mobile, {
                [slide]: !this.state.mobile[slide]
            })
        });
    },
    next() {
        this.selectHouse(this.state.next);
    },
    prev() {
        this.selectHouse(this.state.prev);
    },
    handleMouseEnter(name) {
        this.setState({hover: name});
    },
    handleMouseLeave() {
        this.setState({hover: null});
    },
    render() {
        return (
            <div className={`grid-10 parent ${this.props.className || ""}`}>
                <ul className="grid-10-parent hide-m hide-l hide-xl hide-eo-mobile-house-select">
                    { this.state.data.map(house => (
                        <li key={house.id} className={["mobile-house", house.name, (this.state.mobile[house.id] ? "selected" : "" )].join(" ")}>
                            <h2 className="house-item-title">{`the ${house.name}`}</h2>
                            <button className="eo-btn-outline white" onClick={this.toggleMobileSlide.bind(null, house.id)}>{this.state.mobile[house.id] ? "Close" : "View interior"}</button>
                            { this.state.mobile[house.id] ? (
                                <div className="house-item-content">
                                    <img src={house.urlMobile} className="house-item-img eo-img-fluid"/>
                                    <p className="house-item-copy">{house.summary}</p>
                                </div>
                            ) : null }
                        </li>
                    ))}
                </ul>
                <div className={["eo-house-select grid-10 parent hide-s", this.props.className, typeof this.state.current === "number" ? "selected" : ""].join(" ")}>
                    <div className={`house-bg two-story ${!this.state.hover || this.state.hover === "two-story" ? "show" : ""}`}></div>
                    <div className={`house-bg loft ${this.state.hover === "loft" ? "show" : ""}`}></div>
                    <div className={`house-bg brownstone ${this.state.hover === "brownstone" ? "show" : ""}`}></div>
                    <div className={`house-bg ranch ${this.state.hover === "ranch" ? "show" : ""}`}></div>
                    <ul className={["house-menu grid-10 parent", typeof this.state.current === "number" ? "eo-invisible" : ""].join(" ")}>
                        <li className="eo-info-panel dark">
                            <h2 className="eo-info-panel-header">How many eeros does your home need?</h2>

                            <p className="menu-copy">A set of three will cover the average home (2,000 - 4,000 sq. ft.). But the beauty of eero is that with TrueMesh you can expand your system to cover any home,
                                regardless of its size or shape. Here are a few examples to help you figure out what’s right for your place.</p>
                        </li>
                        {
                         this.state.data.map(house => (
                         <li key={house.id} onClick={this.selectHouse.bind(null, house.id)} onMouseEnter={this.handleMouseEnter.bind(null, house.name)}
                         className={["house-item", house.name].join(" ")}>{`the ${house.name}`}</li>
                         ))
                         }
                    </ul>
                    <div className={["house-carousel grid-10 parent", typeof this.state.current === "number" ? "" : "eo-invisible"].join(" ")}>
                        <ul className="house-carousel-slides grid-10 parent">
                            {
                                this.state.data.map(slide => (
                                    <li key={slide.id}
                                        className={["house-carousel-slide grid-10", slide.name, (this.state.current === slide.id ? "in" : ""), (this.state.last === slide.id ? "in-2" : "")].join(" ")}>
                                        <div className="slide-text-wrap">
                                            <h2 className="standard slide-title">The {slide.name}</h2>
                                            <p className="standard slide-description">{slide.summary}</p>
                                        </div>
                                        <img className="slide-img " src={slide.url}/>
                                        <ul className="slide-pins">
                                            {slide.pins.map((pin, i) =>
                                                <li key={i} className={`pin-list-${i + 1}`}><ul><li className={`float-left slide-pin pins-${slide.pins.length}`}><span
                                                className="pin-icon">{i + 1}</span><p className="pin-text">{pin}</p></li></ul></li>
                                            )}
                                        </ul>
                                    </li>
                                ))
                            }
                        </ul>
                        <button onClick={this.selectHouse.bind(null, null)} className="icon eo-icon-close eo-btn-control eo-btn-close"/>
                        <button onClick={this.prev} className={["icon eo-icon-arrow-left eo-btn-control eo-btn-prev", `slide-${this.state.prev}`].join(" ")}>
                            <p className="eo-btn-control-text hide-s"><span>{`the ${this.state.data[this.state.prev].name}`}</span></p>
                        </button>
                        <button onClick={this.next} className={["icon eo-icon-arrow-right eo-btn-control eo-btn-next", `slide-${this.state.next}`].join(" ")}>
                            <p className="eo-btn-control-text hide-s"><span>{`the ${this.state.data[this.state.next].name}`}</span></p>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
});

export default HouseSelect;



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/in-the-home/components/HouseSelect.js
 **/